import {
    BULK_REQUEST_STATUS,
    IBulkNewReport,
    IBulkRequestCounts,
} from "../../../../../services/api/bulk-rma-action-types";
import { BACKGROUND_JOB_NOTICE_STATE } from "../../stores/background-job-notice-store";

export interface IBulkActionNoticeProgress {
    total: number;
    processed: number;
    percent: number;
}

export function getBulkActionNoticeProgress(
    counts: IBulkRequestCounts,
): IBulkActionNoticeProgress {
    const total = counts.total;
    const remaining = counts.pending + counts.allocated + counts.processing;
    const processed = Math.max(0, total - remaining);
    const percent = total > 0 ? Math.round((processed / total) * 100) : 0;

    return { total, processed, percent };
}

export function getBulkActionNoticeState(
    report: IBulkNewReport,
): BACKGROUND_JOB_NOTICE_STATE {
    if (report.status === BULK_REQUEST_STATUS.PROCESSING) { 
        return BACKGROUND_JOB_NOTICE_STATE.IN_PROGRESS;
    }

    if (report.status === BULK_REQUEST_STATUS.CANCELLED) {
        return BACKGROUND_JOB_NOTICE_STATE.STOPPED;
    }

    const needReview = report.counts.total - report.counts.succeeded
    if (needReview > 0) {
        return BACKGROUND_JOB_NOTICE_STATE.PARTIAL;
    }

    return BACKGROUND_JOB_NOTICE_STATE.COMPLETE;
}

export const BULK_ACTION_NOTICE_TITLE_KEY: Record<BACKGROUND_JOB_NOTICE_STATE, string> = {
    [BACKGROUND_JOB_NOTICE_STATE.IN_PROGRESS]: "BULK_ACTION_NOTICE_IN_PROGRESS_TITLE",
    [BACKGROUND_JOB_NOTICE_STATE.COMPLETE]: "BULK_ACTION_NOTICE_COMPLETE_TITLE",
    [BACKGROUND_JOB_NOTICE_STATE.PARTIAL]: "BULK_ACTION_NOTICE_PARTIAL_TITLE",
    [BACKGROUND_JOB_NOTICE_STATE.STOPPED]: "BULK_ACTION_NOTICE_STOPPED_TITLE",
};
